<template>
  <div class="absolute-full auto-layout flow-col template-container">
    <div style="padding: 5px 5px 5px;">
      <el-form :inline="true" :model="search" size="mini">
        <el-form-item label="平台" prop="platform">
          <el-select v-model="search.platformId" placeholder="请选择"  :clearable="true" style="width: 100px;">
            <el-option
              v-for="item in platforms"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="上游代理" prop="proxyCompanyId">
          <el-select
            v-model="search.proxyCompanyId"
            filterable
            remote
            :remote-method="searchPolicyCompanyProxy"
            :loading="loading"
            placeholder="请输入代理公司名称的关键字进行搜索" :clearable="true"
          >
            <el-option
              v-for="item in proxyCompanies"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="客户ID" prop="adId" >
          <el-input size="mini"
                    placeholder="请输入客户ID"
                    v-model="search.adId"
                    :clearable="true"
          />
        </el-form-item>
        <el-form-item label="消耗月份" prop="costDate" >
          <el-date-picker style="width: 120px;"
                          v-model="search.costDate"
                          type="month"
                          value-format="yyyy-MM"
                          placeholder="选择月">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="客户主体签约名称" prop="adCustomerId">
          <el-select v-model="search.adCustomerId"
                     filterable
                     remote
                     :remote-method="searchAdCustomer"
                     :loading="loading"
                     clearable
                     placeholder="请输入客户名称的关键字进行搜索"
          >
            <el-option
              v-for="item in adCustomers"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" @click="load()" style="margin-right: 10px;">查询</el-button>
        </el-form-item>
        <el-form-item>
          <a :href ="downloadExcel()" class="button" v-authority="'DownloadExcel'" ><i class="el-icon-download"></i>导出excel</a>
        </el-form-item>
      </el-form>
    </div>
    <div class="auto-layout-full" style="position: relative;">
      <el-table
        ref="table"
        slot="center"
        :data="dataList"
        :summary-method="getSummaries"
        show-summary
      >
        <el-table-column prop="platformName" label="平台" width="80px;"></el-table-column>
        <el-table-column prop="proxyCompanyName" label="上游代理" ></el-table-column>
        <el-table-column prop="adCustomerName" label="客户主体签约名称" ></el-table-column>
        <el-table-column prop="adId" label="客户ID" ></el-table-column>
        <el-table-column prop="adName" label="账户名称" ></el-table-column>
        <el-table-column prop="csUserName" label="客服人员"></el-table-column>
        <el-table-column prop="saleUserName" label="销售人员"></el-table-column>
        <el-table-column prop="putTypeName" label="投放方式"></el-table-column>
        <el-table-column prop="costMonth" label="消耗月份" ></el-table-column>
        <el-table-column prop="downCost" label="合鹄结算金额" ></el-table-column>
        <el-table-column prop="upCost" label="上游结算金额"></el-table-column>
        <el-table-column prop="difference" label="差异金额" >
          <template slot-scope="{ row }">
            <span style="color: #f52c34;" v-if="row.difference!==0">{{row.difference}}</span>
            <span  v-else>{{row.difference}}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <pagination
      :total="page.total"
      :start.sync="page.start"
      :limit.sync="page.limit">
    </pagination>
  </div>
  </template>
<script>
  import { getPolicyCompanyByLikenameWithType } from '../../../http/api/policy-company'
  import { getAdPlatformListIdNameMode } from '../../../http/api/ad-platform'
  import { getUpDownCostReportList, getSumCost } from '../../../http/api/up-down-cost-report'
  import { getAdCustomerListByKeyword } from '../../../http/api/ad-customer'
  import { getAdminUrl } from '../../../http/application-api'

  export default {
    data () {
      return {
        dataList: [],
        page: {
          total: 0,
          start: 0,
          limit: this.$shareProps.pageLimit
        },
        search: {
          platformId: null,
          adId: null,
          proxyCompanyId: null,
          costDate: null,
          adCustomerId: null
        },
        proxyCompanies: [],
        platforms: [],
        adCustomers: [],
        loading: false,
        upCost: 0,
        downCost: 0
      }
    },
    computed: {
    },
    mounted () {
      getAdPlatformListIdNameMode()
        .success(resp => {
          this.platforms = resp.data
        })
        .send()
      this.load()
    },
    watch: {
      'page.start' () {
        this.load()
      },
      'page.limit' () {
        this.page.start = 0
      }
    },
    methods: {
      load () {
        let params = Object.assign({}, this.search)
        params.start = this.page.start
        params.limit = this.page.limit
        params.type = 'before'
        this.$pageLoading(true)
        getSumCost()
          .success(resp => {
            if (resp.data) {
              this.upCost = resp.data.upCost
              this.downCost = resp.data.downCost
            }
          })
          .send(params)
        getUpDownCostReportList()
          .complete(() => (this.$pageLoading(false)))
          .success(resp => {
            this.dataList = resp.data.records
            this.page.total = resp.data.total
          })
          .send(params)
      },
      searchPolicyCompanyProxy (keyword) {
        if (keyword && keyword.length > 0) {
          this.loading = true
          getPolicyCompanyByLikenameWithType()
            .complete(() => (this.loading = false))
            .success(resp => {
              this.proxyCompanies = resp.data
            })
            .send(keyword, 1)
        }
      },
      searchAdCustomer (keyword) {
        if (keyword && keyword.length > 0) {
          this.loading = true
          getAdCustomerListByKeyword()
            .complete(() => (this.loading = false))
            .success(resp => {
              this.adCustomers = resp.data
            })
            .send(keyword)
        }
      },
      getSummaries (param) {
        let tmp = ['', '', '', '', '', '', '', '']
        tmp.push('合计：')
        tmp.push(this.downCost)
        tmp.push(this.upCost)
        tmp.push(Math.abs((this.upCost - this.downCost).toFixed(2)))
        return tmp
      },
      downloadExcel () {
        let params = Object.assign({}, this.search)
        params.start = 0
        params.limit = 500 // mybatisplus分页时，每页最大是500，些值不能超过500
        params.type = 'before'
        let arr = []
        for (let key of Object.keys(params)) {
          if (params[key]) {
            arr.push(key + '=' + params[key])
          }
        }
        return getAdminUrl('/up_down_cost_report/download/excel?' + arr.join('&'))
      }
    }
  }
</script>

<style lang="less" scoped>
  @deep: ~'>>>';
  .template-container @{deep} .el-table {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    display: flex;
    flex-flow: column;
  }

  .template-container @{deep} .el-table__body-wrapper {
    flex: 1;
    overflow-y: auto !important;
  }
  .button {
    background-color: #409EFF;
    border: none;
    color: white;
    height: 18px;
    line-height: 18px;
    padding: 5px 10px;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    font-size: 12px;
    outline: none;
  }
</style>
